/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_StoreInputs */

const en_svtag_store = /** @type {(inputs: Svtag_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#STORE`)
};

const ar_svtag_store = /** @type {(inputs: Svtag_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#متجر`)
};

const bn_svtag_store = /** @type {(inputs: Svtag_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#STORE`)
};

const de_svtag_store = /** @type {(inputs: Svtag_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#STORE`)
};

const es_svtag_store = /** @type {(inputs: Svtag_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#STORE`)
};

const fr_svtag_store = /** @type {(inputs: Svtag_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#STORE`)
};

const pt_svtag_store = /** @type {(inputs: Svtag_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#STORE`)
};

const zh_svtag_store = /** @type {(inputs: Svtag_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#STORE`)
};

const tr_svtag_store = /** @type {(inputs: Svtag_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#STORE`)
};

const ru_svtag_store = /** @type {(inputs: Svtag_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#STORE`)
};

const pl_svtag_store = /** @type {(inputs: Svtag_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#STORE`)
};

/**
* | output |
* | --- |
* | "#STORE" |
*
* @param {Svtag_StoreInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_store = /** @type {((inputs?: Svtag_StoreInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_StoreInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_store(inputs)
	if (locale === "bn") return bn_svtag_store(inputs)
	if (locale === "de") return de_svtag_store(inputs)
	if (locale === "es") return es_svtag_store(inputs)
	if (locale === "fr") return fr_svtag_store(inputs)
	if (locale === "pt") return pt_svtag_store(inputs)
	if (locale === "zh") return zh_svtag_store(inputs)
	if (locale === "tr") return tr_svtag_store(inputs)
	if (locale === "ru") return ru_svtag_store(inputs)
	if (locale === "pl") return pl_svtag_store(inputs)
	return en_svtag_store(inputs)
});